import { v4 as uuidv4 } from 'uuid';
import Cookies from 'js-cookie';
import { GUEST_COOKIE_NAME, GUEST_COOKIE_EXPIRY_DAYS } from '../constants/guestConstants';
import { isAuthenticated } from "./authStorage";

/**
 * Generate a unique guest user ID using UUID v4
 * @returns {string} UUID string
 */
export const generateGuestUID = () => {
  return uuidv4();
};

/**
 * Set guest UID in cookie
 * @param {string} guestUID - The guest user ID to store
 */
export const setGuestCookie = (guestUID) => {
  Cookies.set(GUEST_COOKIE_NAME, guestUID, {
    expires: GUEST_COOKIE_EXPIRY_DAYS,
    path: '/',
    sameSite: 'Lax',
  });
};

/**
 * Get guest UID from cookie
 * @returns {string|null} Guest UID or null if not found
 */
export const getGuestCookie = () => {
  return Cookies.get(GUEST_COOKIE_NAME) || null;
};

/**
 * Remove guest UID cookie
 */
export const removeGuestCookie = () => {
  Cookies.remove(GUEST_COOKIE_NAME, { path: '/' });
};

/**
 * Get or create guest UID
 * If cookie exists, return it. Otherwise, create a new one.
 * @returns {string} Guest UID
 */
export const getOrCreateGuestUID = () => {
  let guestUID = getGuestCookie();
  
  if (!guestUID) {
    guestUID = generateGuestUID();
    setGuestCookie(guestUID);
  }
  
  return guestUID;
};

/**
 * Check if user is a guest (no auth token but has guest cookie or no cookie)
 * @returns {boolean} True if user is guest
 */
export const isGuestUser = () => {
  return !isAuthenticated();
};
